/* eslint-disable default-case */
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = {}, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {
                uid : action.uid,
            }
        case 'LOGOUT':
            return {}
        default:
            return state
    }
}